import { Routes } from '@angular/router';
import { RenderizadorPaginaComponent } from '@core/components/renderizador-pagina/renderizador-pagina.component';
import { onboardingSecuenciaGuard } from '@core/guards/secuencia/onboarding-secuencia.guard';
import { resolucionPaginaDinamica } from '@core/resolvers/pagina-dinamica.resolver';
import { sesionResolver } from '@core/resolvers/sesion.resolver';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'bienvenida' },

  {
    path: ':slug',
    component: RenderizadorPaginaComponent,
    canActivate: [onboardingSecuenciaGuard],
    resolve: { datosPagina: resolucionPaginaDinamica, sesion: sesionResolver },
  },

  {
    path: '**',
    redirectTo: 'bienvenida',
  },
];
